import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: null,
    auth: {},
    tooltips:{
      reportPeriod:{
        visible:true,
        dismissed:false
      },
      website:{
        visible:true,
        dismissed:false
      },
      format:{
        visible:true,
        dismissed:false
      },
      placement:{
        visible:true,
        dismissed:false
      }
    }
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload
    },
    auth: (state, payload) => {
      localStorage.setItem('auth', payload.token_type + ' ' + payload.access_token);

      axios.defaults.headers.common['Authorization'] = payload.token_type + ' ' + payload.access_token;

      state.auth = payload.token_type + ' ' + payload.access_token

    },
    loadTooltips(state,payload){

      let tooltipState = JSON.parse(payload)
      if(!tooltipState.website.dismissed) tooltipState.website.visible = true
      if(!tooltipState.format.dismissed) tooltipState.format.visible = true
      if(!tooltipState.placement.dismissed) tooltipState.placement.visible = true
      state.tooltips = tooltipState
    },
    saveTooltipState(state,payload){
      localStorage.setItem("tooltips-state",JSON.stringify(state.tooltips))
    },
    logout(state, payload) {
      state.auth = {};
      localStorage.removeItem('auth');
    },
  },

  actions: {
    login({commit}, payload) {
      return new Promise((resolve, reject) => {
        // axios.post('auth/attempt', payload, {baseURL: 'http://service.admanager.yobee.lo/api/'}).then(response => {
          // axios.post('auth/attempt', payload, {baseURL: 'http://service.admanager.yobee.lo/api/'}).then(response => {
          // axios.post('auth/attempt', payload, {baseURL: 'http://staging.admin.yobee.it/api/'}).then(response => {
          axios.post('auth/attempt', payload, {baseURL: 'https://admin.yobee.it/api/'}).then(response => {
          commit('auth', response.data)
          resolve();

        }).catch(error => {
          reject()
        })

      })
    },

    me({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.get('me').then(response => {
          // console.log(response);
          resolve(response);
        }).catch(error => {
          reject(error);
        })

      })
    },

    updatePassword({commit}, payload){
      return new Promise((resolve, reject)=>{
        axios.post('me/password', payload).then(response=>{
          resolve();
        }).catch(error=>{
          reject(error);
        })
      })
    },

    updateUser({commit}, payload){
      return new Promise((resolve, reject)=>{
        axios.put('me', payload).then(response=>{
          resolve();
        }).catch(error=>{
          console.log(error)
          reject(error);
        })
      })
    },

    websites({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.get('website').then(response => {
          resolve(response);
        }).catch(error => {
          reject(error)
        })

      })
    },

    // website({commit}, payload) {
    //     return new Promise((resolve, reject) => {
    //         axios.get('website/'+payload.id).then(response => {
    //         resolve(response);
    //         }).catch(error => {
    //             reject(error)
    //         })
    //
    //     })
    // },

    reports({commit}, payload){
      return new  Promise((resolve, reject)=>{
        axios.get('/reports?'+payload).then(response =>{
          resolve(response);
        }).catch(error=>{
          reject(error);
        })
      })
    },
    adunit({commit}, payload){
      return new  Promise((resolve, reject)=>{
        axios.get('/adunit/types').then(response =>{
          resolve(response);
        }).catch(error=>{
          reject(error);
        })
      })
    },
    hideTooltip({state,commit},payload){
      console.log("macjs dguid ",payload)
      state.tooltips[payload].visible = false
      commit("saveTooltipState")
    },
    dismissTooltip({state,commit},payload){
      state.tooltips[payload].visible = false
      state.tooltips[payload].dismissed = true
      commit("saveTooltipState")
    },
  },

  getters: {
    auth: state => {
      if (!Object.keys( state.auth)) {
        state.auth = localStorage.getItem('auth')
      }
      return state.auth
    },
    isReportPeriodTooltipVisible : state => !state.tooltips.reportPeriod.dismissed && state.tooltips.reportPeriod.visible,
    isWebsiteTooltipVisible : state => !state.tooltips.website.dismissed && state.tooltips.website.visible,
    isFormatTooltipVisible : state => !state.tooltips.format.dismissed &&  state.tooltips.format.visible,
    isPlacementTooltipVisible : state => !state.tooltips.placement.dismissed &&  state.tooltips.placement.visible,
  }
})
